module.exports = __webpack_public_path__ + "static/media/login-form.b963aee0.png";